"use client";

import { ResumeExample } from "@resume-studio/dto";
import { ResumeSamples } from "@resume-studio/ui";

type ResumeSamplesWrapperProps = {
  data: ResumeExample[];
};

export const ResumeSamplesWrapper: React.FC<ResumeSamplesWrapperProps> = ({ data }) => {
  // eslint-disable-next-line unicorn/consistent-function-scoping
  const onTemplateSelected = (resume: ResumeExample | null) => {
    const url = `${process.env.NEXT_PUBLIC_APP_URL}/create?id=${resume?.id}&type=resume`;
    window.open(url, "_blank");
  };
  return <ResumeSamples resumeExamples={data} onTemplateSelected={onTemplateSelected} />;
};
